import defaultClient from '@/plugins/axios/defaultClient'
import qs from 'query-string'

export default {
  getProductsDetailDownloadExcel(uuid, fileName = 'Excel로내보내기') {
    defaultClient({
      method: 'GET',
      url: `/product-lists/${uuid}/download`,
      responseType: 'blob',
    }).then((res) => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: res.headers['content-type'] }),
      )
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${fileName}.xlsx`)
      document.body.appendChild(link)
      link.click()
    })
  },
  /**
   * 목록조회
   * @param {
   * {
   *  date: yyyy-MM-dd
   *  type: sales_list (매출) / purchase_list (사입) / tab (외상)
   * }
   * } query
   * @returns
   */
  getProducts(query) {
    return defaultClient.get(`/product-lists?${qs.stringify(query)}`)
  },
  /**
   *
   * @param {*} uuid
   * @returns
   */
  getProductsDetail(uuid) {
    return defaultClient.get(`/product-lists/${uuid}`)
  },
  /**
   *
   * @param {*} uuid
   * @returns
   */
  removeProductsDetail(uuid) {
    return defaultClient.delete(`/product-lists/${uuid}`)
  },
  /**
   *
   * @param {
   *   {
   *     "date": "2022-06-29",
   *     "type": "tab",
   *     "itemSet": [
   *         {
   *             "title": "민트 하우스",
   *             "purchaseUnitCost": 15000,
   *             "quantity": 3,
   *             "requestType": "사입",
   *             "wholesaler": "0cded28d-7cd2-440b-b843-63534bb51387",
   *             "option": "F-화이트",
   *             "memo": "",
   *             "reference": "f240980f-8dae-42bf-bf8a-0766f65f86eb"
   *         },
   *         {
   *             "title": "캘리 오버숄더크립자켓",
   *             "purchaseUnitCost": 15000,
   *             "quantity": 3,
   *             "requestType": "사입",
   *             "wholesaler": "0cded28d-7cd2-440b-b843-63534bb51387",
   *             "option": "F-화이트",
   *             "memo": "",
   *             "reference": null
   *         }
   *     ]
   * }
   * } product
   * @returns
   */
  postProducts(product) {
    return defaultClient.post('/product-lists', product)
  },
  /**
   *
   * @param {*} uuid
   * @returns
   */
  postProductsDetailStatus({ uuid, status }) {
    return defaultClient.post(`/product-lists/${uuid}/${status}`)
  },
  /**
   * 상품 단건 추가
   * @returns
   */
  postProductItem(product) {
    return defaultClient.post('/product-list-items', product)
  },
  /**
   * 상품 단건 수정
   * @param {*} uuid
   * @returns
   */
  putProductItem(uuid, product) {
    return defaultClient.put(`/product-list-items/${uuid}`, product)
  },
  /**
   * 상품 단건 삭제
   * @param {*} uuid
   * @returns
   */
  deleteProductItem(uuid) {
    return defaultClient.delete(`/product-list-items/${uuid}`)
  },
  /**
   *
   * @param {
   *  "date": "2022-08-02"
   *  "file": file
   * }store
   * @returns
   */
  postProductListFiles(productListFiles) {
    const formData = new FormData()
    for (const k in productListFiles) {
      formData.append(k, productListFiles[k])
    }

    return defaultClient.post('/product-list-files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  /**
   *
   * @param {
   *  "date": "2022-08-02"
   * } query
   * @returns
   */
  getProductListFiles(query) {
    return defaultClient.get(`/product-list-files?${qs.stringify(query)}`)
  },
  /**
   *
   * @param {
   *  "uuid": 파일 uuid
   * } query
   * @returns
   */
  deleteProductListFiles({ uuid }) {
    return defaultClient.delete(`/product-list-files/${uuid}`)
  },
}
